// Single source of truth for displaying user-account role labels in the UI.
// Internal role strings stay stable in the DB and RBAC layer — this file only
// controls what the user sees.
//
// Per Harvey Dunn meeting (2026-04-30):
//   - "Contractor admin" / contractor company admin → "Contractor"
//   - "Contractor" / on-site contractor staff → "Engineer"

export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  'property-onboarding-staff': 'Onboarding Staff',
  viewer: 'Viewer',
  demo: 'Demo',
  staff: 'Staff',
  fm: 'FM',
  cloud_staff: 'Cloud Staff',
  building_manager: 'Building Manager',
  concierge: 'Concierge',
  contractor: 'Contractor',
};

// Short abbreviations for narrow viewports.
export const ROLE_LABELS_SHORT = {
  super_admin: 'S.Admin',
  admin: 'Admin',
  'property-onboarding-staff': 'Onboard',
  viewer: 'Viewer',
  demo: 'Demo',
  staff: 'Staff',
  fm: 'FM',
  cloud_staff: 'Cloud',
  building_manager: 'BM',
  concierge: 'Conc',
  contractor: 'Contr',
};

const isAdminFlag = (flag) => flag === true || flag === 'true' || flag === 1 || flag === '1';

export const getRoleLabel = (role, opts = {}) => {
  if (!role) return '';
  if (role === 'contractor') {
    if (isAdminFlag(opts.isCompanyAdmin)) return 'Contractor';
    return 'Engineer';
  }
  return ROLE_LABELS[role] || role;
};

export const getRoleLabelShort = (role, opts = {}) => {
  if (!role) return '';
  if (role === 'contractor') {
    if (isAdminFlag(opts.isCompanyAdmin)) return 'Contr';
    return 'Eng';
  }
  return ROLE_LABELS_SHORT[role] || ROLE_LABELS[role] || role;
};

export const getCurrentUserRoleLabel = () => {
  if (typeof localStorage === 'undefined') return '';
  const role = localStorage.getItem('userRole');
  const isCompanyAdmin = localStorage.getItem('isCompanyAdmin');
  return getRoleLabel(role, { isCompanyAdmin });
};

export const getCurrentUserRoleLabelShort = () => {
  if (typeof localStorage === 'undefined') return '';
  const role = localStorage.getItem('userRole');
  const isCompanyAdmin = localStorage.getItem('isCompanyAdmin');
  return getRoleLabelShort(role, { isCompanyAdmin });
};
